import { useState } from 'react'
import { Languages } from 'lucide-react'

export default function LocaleToggle({ enabled, onChange }) {
  return (
    <button
      onClick={() => onChange(!enabled)}
      className={`inline-flex items-center px-4 py-2 rounded-lg border transition-colors ${
        enabled
          ? 'bg-blue-50 border-blue-300 text-blue-700'
          : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
      }`}
      title={
        enabled
          ? 'Hide items from other locales'
          : 'Show items from other locales'
      }
    >
      <Languages className="h-4 w-4 mr-2" />
      {enabled ? 'Showing All Locales' : 'Show All Locales'}
    </button>
  )
}
